import React from 'react';

const Header = ({ logo, title }) => (
    <header className="bg-gray-100 p-6 text-center flex flex-row items-center justify-center space-x-4">
      <img src={logo} alt="Restaurant Logo" className="h-20 w-20 object-cover rounded-full" />
      <h1 className="text-4xl font-bold">{title}</h1>
    </header>
  );

export default Header;